<template>

	<div>
		<nav-bar-home></nav-bar-home>
		<main id="main" class="account dashboard">

			<section class="account-content parten-bg">
				<div class="container-fluid" >

					<div class="row acc-dashboard">
						<!--Account Sidebar: End-->
						<!-- <aside class="col-md-3 col-sm-4 col-xs-12 account-sidebar sidebar">
						<h3 class="acc-title lg">Account</h3>
						<ul>
							<li class="active">
								<a href="myaccount-dashboard.html" title="account dashboard">Account Dashboard</a>
							</li>
							<li>
								<a href="myaccount-information.html" title="account dashboard">Account information</a>
							</li>
							<li>
								<a href="myaccount-address.html" title="account dashboard">Address Book</a>
							</li>
							<li>
								<a href="myaccount-order.html" title="account dashboard">My Orders</a>
							</li>
							<li>
								<a href="wishlist.html" title="account dashboard">Wishlist</a>
							</li>
							<li>
								<a href="myaccount-newsletter.html" title="account dashboard">Newsletter Subscriptions</a>
							</li>
						</ul>
					</aside> -->
						<!--Account main content : Begin -->
						<section class="account-main col-md-12 col-xs-12">
							<div class="row" style="margin:0;">
								<div class="col-12">
									<h3 class="acc-title lg text-center" style="margin-top:15px;"> WELLCOME {{ user?.accountTitle }} (DUBLIN) TO YOUR
										CUSTOMER AREA </h3>
								</div>
								<div class="col-12">
									<dashboard-stats></dashboard-stats>
								</div>

							</div>

							<h3 class="acc-title lg">My Addresses
							</h3>
							<div class="row db-content">
								<div class="db-hello col-xs-12">
									<div class="pad-1015">
										<p class="hello-user">
											Hello, {{ user.accountTitle ? user.accountTitle : user.name }}!
											<span class="link ddarker" style="float: right"
												@click="goTo('/checkout')">Go To Checkout</span>
										</p>

									</div>
								</div>
								<template v-if="hasAddresses">
								<div v-if="userAddresses.length == 1" class="clearfix">
									<div class="col-md-6 col-sm-6 db-contact address-card" v-for="address in userAddresses"
										:key="address._id">
										<h4 class="acc-title h-icon"
											v-if="user.address && address._id == user.address._id">
											Default Delivery Information
											<!-- <a href="#" class="acc-edit" title="edit address">
												<i class="fa fa-pencil-square-o"></i>
											</a> -->
										</h4>
										<h4 class="acc-title h-icon" v-else>
											Delivery Information
											<!-- 											
											<span class="acc-edit link" title="edit address">
												Set as Default
										</span> -->
										</h4>
										<div class="acc-info-content pad-1015">
											<div>
												<span style="display:inline-block;width:120px;">Business Name:</span>
												<span style="display:inline-block;width:140px;">{{ address.businessName || user.accountTitle }}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Address Line 1:</span>
												<span style="display:inline-block;width:140px;">{{ address.addressOne
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Address Line 2</span>
												<span style="display:inline-block;width:140px;">{{ address.addressTwo
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">City/Town:</span>
												<span style="display:inline-block;width:140px;">{{ address.city
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">County:</span>
												<span style="display:inline-block;width:140px;">{{ address.county
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Country:</span>
												<span style="display:inline-block;width:140px;">{{ address.country
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">PostCode:</span>
												<span style="display:inline-block;width:140px;">{{ address.postCode
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Contact Name:</span>
												<span style="display:inline-block;width:140px;">{{ address.contactName
													}}</span>
											</div>
											<div>
												<span style="display:inline-block;width:120px;">Mobile Number:</span>
												<span style="display:inline-block;width:140px;">{{ formatMobile(address.mobileNumber)
													}}</span>
											</div>
											<div>
												<span class="addr-badge-link"
													v-if="user.address && address._id !== user.address._id"
													@click="updateDefaultAddress(address._id)">Set As Default Delivery
													Address</span>
												<span class="addr-badge-link" v-if="!user.address"
													@click="updateDefaultAddress(address._id)">Set As Default Delivery
													Address</span>
											</div>
											<div>
												<span class="addr-badge-link" v-if="user.billing == null"
													@click="updateDefaultBillingAddress(address._id)">Set As Billing
													Address</span>
												<span class="addr-badge-link"
													v-else-if="address._id !== user.billing._id"
													@click="updateDefaultBillingAddress(address._id)">Set As Billing
													Address</span>
											</div>
											<!-- <div>
												<span style="display:inline-block;width:120px;">Status:</span>
										        <span style="display:inline-block;width:120px;">OFF</span>
											</div> -->
										</div>
									</div>
								</div>
								<div v-else class="clearfix">
									<div class="addr-table-wrap">
									<table class="table table-bordered table-responsive addresses-table">
										<thead class="acc-title lg">
											<tr>
												<th scope="col">Business Name</th>
													<th scope="col">Address Line 1</th>
												<th scope="col">Address Line 2</th>
												<th scope="col">City/Town</th>
												<th scope="col">County</th>
												<th scope="col">Country</th>
												<th scope="col">Post Code</th>
												<th scope="col">Contact Name</th>
												<th scope="col">Mobile No</th>
												<th scope="col">Set As Default Delivery Address / Billing Address</th>
												<th scope="col">Action</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="address in userAddresses" :key="address._id">
												<td>{{ address.businessName }}</td>
													<td>{{ address.addressOne }}</td>
												<td>{{ address.addressTwo }}</td>
												<td>{{ address.city }}</td>
												<td>{{ address.county }}</td>
												<td>{{ address.country }}</td>
												<td>{{ address.postCode }}</td>
												<td>{{ address.contactName }}</td>
												<td>{{ formatMobile(address.mobileNumber) }}</td>
												<td>
													<div>
														<span class="addr-badge-link"
															v-if="user.address && address._id !== user.address._id"
															@click="updateDefaultAddress(address._id)">Set As Default
															Delivery Address</span>
														<span class="addr-badge-link" v-else-if="!user.address"
															@click="updateDefaultAddress(address._id)">Set As Default
															Delivery Address</span>
														<span class="addr-badge-active" v-else>Active (Delivery
															Address)</span>
													</div>
													<div>
														<span class="addr-badge-link" v-if="user.billing == null"
															@click="updateDefaultBillingAddress(address._id)">Set As
															Billing Address</span>
														<span class="addr-badge-link"
															v-else-if="address._id !== user.billing._id"
															@click="updateDefaultBillingAddress(address._id)">Set As
															Billing Address</span>
														<span class="addr-badge-active" v-else>Active (Billing
															Address)</span>
													</div>
												</td>
												<td>
													<!-- Delete button -->
													<button class="btn btn-danger addr-delete-btn" @click="deleteAddress(address._id)"
														:disabled="isAddressActive(address)">Delete</button>
												</td>
											</tr>
										</tbody>
									</table>
									</div>
								</div>
								</template>

								<div class="col-12 addresses-toolbar" v-if="hasAddresses && user.isUserType !== 'dentalcare' && !showAddForm">
									<button class="btn btn-primary" @click="showAddForm = true">
										+ Add New Address
									</button>
								</div>
								<div class="col-md-6 col-sm-6 db-contact address-form-card"
									v-if="user.isUserType !== 'dentalcare' && (!hasAddresses || showAddForm)">
									<h4 class="acc-title h-icon address-form-header">
										Add New Address
										<button v-if="hasAddresses" type="button" class="address-form-cancel"
											@click="showAddForm = false">Cancel</button>
									</h4>
									<div class="" style="padding:10px;">
										<label for="">Business Name</label>
										<input type="text" name="" placeholder="Business Name" v-model="businessName"
											id="" class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Address Line 1</label>
										<input type="text" name="" placeholder="Address Line 1" v-model="addLineOne"
											id="" class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Address Line 2(Optional)</label>
										<input type="text" name="" placeholder="Address Line 2" v-model="addLineTwo"
											id="" class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">City/Town</label>
										<input type="text" name="" placeholder="City" v-model="city" id=""
											class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">County</label>
										<input type="text" name="" placeholder="County" v-model="county" id=""
											class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Country</label>
										<input type="text" name="" placeholder="Country" v-model="country" id=""
											class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Post Code</label>
										<input type="text" name="" placeholder="Post Code" v-model="postCode" id=""
											class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Contact Name</label>
										<input type="text" name="" placeholder="Contact Name" v-model="contactName"
											id="" class="form-control">
									</div>
									<div class="" style="padding:10px;">
										<label for="">Mobile No</label>
										<input type="text" name="" placeholder="Mobile No" v-model="mobileNumber" maxlength="11" @input="mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)"
											id="" class="form-control">
									</div>
									<button class="btn btn-primary form-control" @click="addAddress" :disabled="verify">
										Add Address </button>
								</div>

							</div>
						</section><!-- Cart main content : End -->
					</div>

				</div>
			</section>
		</main><!-- Main Category: End -->
		<!--Footer : Begin-->
		<div>
			<footer-section></footer-section>
		</div>
	</div>
</template>


<script>
import NavBarHome from "@/components/NavBarHome.vue"
import DashboardStats from "./DashboardStats.vue"
import FooterSection from "@/components/FooterSection.vue"
import { mapState } from 'vuex';

export default {
	components: { DashboardStats, NavBarHome, FooterSection },

	computed: {
		...mapState(['user', 'userAddresses']),
		hasAddresses() {
			return this.userAddresses.length > 0
		},
		verify() {
			if (this.isSubmitting || this.addLineOne.length < 1 || this.city.length < 1 || this.county.length < 1 || this.country.length < 1 || this.postCode.length < 1 || this.contactName.length < 1 || this.mobileNumber.length < 1) {
				return true
			} else {
				return false
			}
		}

	},
	methods: {
		formatMobile(value) {
			if (value === undefined || value === null) return '';
			let mob = String(value).trim();
			if (!mob.length || mob === 'undefined' || mob === 'null') return '';
			if (mob.startsWith('+') || mob.startsWith('0')) return mob;
			return '0' + mob;
		},
		goTo(path) {
			location.replace(path)
		},
		async updateDefaultAddress(id) {
			this.error = ''
			let dec = await this.$store.dispatch("setDefaultAddress", { id, user: this.user._id })
			if (dec.status) {
				this.$store.dispatch("getUser")
			} else {
				this.error = dec.message
			}
		},
		isAddressActive(address) {
			// Check if the address is active (delivery or billing)
			if (this.user.address && address._id === this.user.address._id) {
				return true; // Disable button if address is active delivery address
			} else if (this.user.billing && address._id === this.user.billing._id) {
				return true; // Disable button if address is active billing address
			} else {
				return false; // Enable button otherwise
			}
		},
		async updateDefaultBillingAddress(id) {
			// console.log(id);
			// return
			this.error = ''
			let dec = await this.$store.dispatch("setDefaultBillingAddress", { id, user: this.user._id })
			if (dec.status) {
				this.$store.dispatch("getUser")
			} else {
				this.error = dec.message
			}
		},
		async deleteAddress(addressId) {
			try {
				const dec = await this.$store.dispatch("deleteAddress", addressId)
				if (dec.status) {
					this.$store.dispatch("getUser")
				} else {
					this.error = dec.message
				}
			} catch (error) {
				console.error("Error deleting address:", error);
				throw error;
			}
		},
		async addAddress() {
			if (!this.verify) {
				this.isSubmitting = true
				this.error = ''
				let address = {
					user: this.user._id,
					businessName: this.businessName,
					addressOne: this.addLineOne,
					addressTwo: this.addLineTwo,
					city: this.city,
					county: this.county,
					country: this.country,
					postCode: this.postCode,
					contactName: this.contactName,
					mobileNumber: this.mobileNumber
				}
				try {
					let dec = await this.$store.dispatch("addAddress", address)
					if (dec.status) {
						this.businessName = ''
						this.addLineOne = ''
						this.addLineTwo = ''
						this.city = ''
						this.county = ''
						this.country = ''
						this.postCode = ''
						this.mobileNumber = ''
						this.contactName = ''
						this.showAddForm = false
						this.$store.dispatch("getUser")
					} else {
						this.error = dec.message
					}
				} catch (err) {
					this.error = err.message || 'An error occurred'
				} finally {
					this.isSubmitting = false
				}
			}
		}
	},
	data() {
		return {
			businessName: '',
			addLineOne: '',
			addLineTwo: '',
			city: '',
			county: '',
			country: '',
			postCode: '',
			mobileNumber: '',
			contactName: '',
			error: '',
			isSubmitting: false,
			showAddForm: false,
		}
	},
	mounted() {

	}
}
</script>

<style>
.link {
	text-decoration: underline;
}

.span-link {
	cursor: pointer;
	text-decoration: underline;
}

.span-link:hover {
	transition: all 200ms;
	font-weight: 700;
}

.ddarker {
	font-weight: bold;
	color: #444444;
	font-size: 18px;
	padding-bottom: 10px;
	position: relative;
}

.table-cart.table {
	margin-top: 45%;
	background-color: #ffffff;
	border: 1px solid #f1f1f1;
	border-top: none;
}

.table th {
	background-color: #f5f5f5;
	font-weight: bold;
	/* Add any other styles as needed */
}

thead.acc-title.lg tr th {
	background-color: #fd5b4e;
	font-weight: 500;
}
.account.dashboard{
	padding-bottom: 50px;
}
.addresses-toolbar {
	clear: both;
	margin: 10px 0 20px;
	width: 100%;
}

.addresses-toolbar .btn {
	border-radius: 24px;
	padding: 9px 22px;
	font-weight: 600;
	font-size: 14px;
	border: none;
	transition: opacity .15s ease;
}

.addresses-toolbar .btn:hover {
	opacity: .9;
}

.address-card {
	background: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
	border: 1px solid #f1f1f1;
}

.address-card .acc-info-content {
	padding: 18px 22px;
}

.address-card .acc-info-content > div {
	padding: 6px 0;
	border-bottom: 1px solid #f5f5f5;
}

.address-card .acc-info-content > div:nth-last-child(-n+2) {
	border-bottom: none;
}

.addr-badge-link {
	display: inline-block;
	margin: 4px 6px 4px 0;
	padding: 5px 14px;
	border-radius: 20px;
	background: #fff0ee;
	color: #fd5b4e !important;
	font-weight: 700;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: .02em;
	cursor: pointer;
	text-decoration: none !important;
	transition: background .2s ease, color .2s ease;
}

.addr-badge-link:hover {
	background: #fd5b4e;
	color: #fff !important;
}

.addr-badge-active {
	display: inline-block;
	margin: 4px 6px 4px 0;
	padding: 5px 14px;
	border-radius: 20px;
	background: #e8f5e9;
	color: #2e7d32;
	font-weight: 700;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: .02em;
	border: 1px solid #c8e6c9;
}

.addr-table-wrap {
	margin: 10px 0 0;
	overflow: auto;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
	border: 1px solid #eee;
}

.addresses-table {
	margin: 0 !important;
	border: none !important;
}

.addresses-table thead th {
	background: #fff5f4 !important;
	color: #3a3a3a !important;
	text-transform: uppercase;
	font-size: 12px;
	letter-spacing: .04em;
	font-weight: 700 !important;
	padding: 14px 16px;
	white-space: nowrap;
	border: none !important;
	border-bottom: 2px solid #fd5b4e !important;
}

.addresses-table tbody td {
	padding: 14px 16px;
	font-size: 14px;
	vertical-align: middle;
	border-top: none !important;
	border-bottom: 1px solid #f0f0f0 !important;
}

.addresses-table tbody tr:last-child td {
	border-bottom: none !important;
}

.addresses-table tbody tr:nth-child(even) {
	background: #fafbfc;
}

.addresses-table tbody tr:hover {
	background: #fff4f2;
}

.addr-delete-btn {
	border-radius: 20px;
	padding: 6px 16px;
	font-size: 12px;
	font-weight: 600;
	border: none;
}

.address-form-card {
	clear: both;
	background: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
	border: 1px solid #f1f1f1;
	padding-bottom: 20px;
	margin-top: 20px;
}

.address-form-card .form-control {
	border-radius: 8px;
	border: 1px solid #e3e3e3;
	transition: border-color .2s ease, box-shadow .2s ease;
}

.address-form-card .form-control:focus {
	border-color: #fd5b4e;
	box-shadow: 0 0 0 3px rgba(253, 91, 78, 0.15);
	outline: none;
}

.address-form-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.address-form-cancel {
	background: transparent;
	border: 1px solid rgba(255, 255, 255, 0.7);
	color: #fff;
	border-radius: 20px;
	padding: 4px 16px;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: .02em;
	cursor: pointer;
	transition: background .2s ease;
}

.address-form-cancel:hover {
	background: rgba(255, 255, 255, 0.18);
}

.address-form-card label {
	font-weight: 600;
	color: #555;
	font-size: 13px;
	margin-bottom: 6px;
	display: block;
}

.address-form-card > div {
	padding: 8px 22px !important;
}

.address-form-card button.btn.btn-primary.form-control {
	border-radius: 24px;
	margin: 10px 22px 0;
	width: calc(100% - 44px);
	padding: 11px;
	font-weight: 600;
}

/* Below desktop width, let the single-address card and the add-address form
   take the full row instead of Bootstrap's col-sm-6/col-md-6 half-width —
   at tablet/phone sizes a 50%-wide card leaves the form fields too cramped. */
@media (max-width: 991.98px) {
	.address-card,
	.address-form-card {
		width: 100% !important;
		max-width: 100% !important;
		float: none !important;
	}
}

@media (max-width: 768px) {
	.row.acc-dashboard {
		padding: 0 15px;
	}
	.row.db-content{
		margin: 20px 0px !important;
	}    
	.row.db-content {
        overflow: auto;
        text-wrap: nowrap;
    }

	.calculate-spend {
		margin-top: 10px;
	}

	.table-res {
		overflow: auto;
		text-wrap: nowrap;
	}

	.table-res th,
	.table-res td {
		padding: 10px 20px !important;
	}

	a.product-name {
		font-size: 15px;
		padding: 10px;
	}
	.db-contact > div{
		padding: 0px  !important;
	}
	.db-contact > .btn.btn-primary.form-control{
		margin-bottom: 10px;
	}
	.db-contact > .acc-info-content {
		padding: 10px 0px !important;
	}

}


/* 9 Sept 2025 */
.container .col-md-6 input{
	margin:0 0 0;
}
.account.dashboard span{
	color:initial;
}

@media(max-width:768px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 28%;
        margin-top: 11%;
    }
	
}

@media(max-width:550px){
	    .user-dashboard-menuWrap .c-icon {
        margin-left: 33%;
        margin-top: 16%;
    }
}


/* Address cards: fixed label column + flexible value column so long
   values (e.g. business name) no longer wrap into a misaligned block.
   Applies only to label + value display rows (not edit forms / email list). */
.col-md-6.db-contact .acc-info-content > div:has(> span[style*="140px"]:last-child:not(:first-child)) {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	margin-bottom: 4px;
}
.col-md-6.db-contact .acc-info-content > div > span[style*="120px"]:first-child:not(:last-child),
.col-md-6.db-contact .acc-info-content > div > span[style*="150px"]:first-child:not(:last-child) {
	flex: 0 0 140px;
	width: 140px !important;
}
.col-md-6.db-contact .acc-info-content > div > span[style*="140px"]:last-child:not(:first-child) {
	flex: 1;
	width: auto !important;
	word-break: break-word;
	font-weight: 500;
}

</style>